










import { Vue, Component } from 'vue-property-decorator';
import Evento from '@/pantallas/CopilotoVirtual/Eventos/CopilotoEvento.vue';

@Component({
  components: { Evento },
})
export default class EventoPantalla extends Vue {}
